// Re-export CierresScreen como CierreScreen para compatibilidad con navegación existente
import CierresScreen from './CierresScreen';
export default CierresScreen;
